export default "__VITE_ASSET__CVREoA3r__"